<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item['tool']" class="hidden-md-and-down">
            <h1><v-icon large>mdi-clipboard-list</v-icon>{{ item['tool'].name }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <SetupDefinitionSubForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import SetupDefinitionSubForm from '../../components/setupdefinitionsub/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'SetupDefinitionSub';
const routeAfterDel = 'SetupDefinitionUpdate';
const routeAfterDelId = 'setupDefinition';
export default {
  name: 'SetupDefinitionSubUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    SetupDefinitionSubForm
  },

  computed: {
    ...mapFields('setupdefinitionsub', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('setupdefinitionsub', ['find'])

  },

  methods: {
    ...mapActions('setupdefinitionsub', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
